<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Items de PV vencidos</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 md3>
                <empresa-select v-model="empresa_id" @actualiza="datos()"></empresa-select>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-card-title>
                        <v-btn color="primary" dark @click.native="filterModal = true">
                            Filtros
                            <v-icon right>filter_list</v-icon>
                        </v-btn>
                        <v-text-field
                                label="Búsqueda"
                                prepend-icon="search"
                                v-model="search"
                                v-debounce:300ms="datos">
                        </v-text-field>
                    </v-card-title>
                    <v-data-table
                            :pagination.sync="pag"
                            :total-items="totalItems"
                            :loading="loading"
                            :rows-per-page-items="rows"
                            rows-per-page-text="Filas por pagina"
                            no-data-text="No hay datos"
                            disable-initial-sort
                            :headers="headers"
                            :items="items"
                            class="tabla-compacta-col"
                            expand
                    >
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-center">{{ props.item.C5_EMISSAO | fecha }}</td>
                            <td class="text-xs-center">{{ props.item.C9_DATALIB | fecha }}</td>
                            <td class="text-xs-center">{{ props.item.C9_PEDIDO }}</td>
                            <td class="text-xs-center">{{ props.item.C9_ITEM }}</td>
                            <td class="text-xs-left">{{ props.item.C9_PRODUTO }} | {{ props.item.B1_DESC }}</td>
                            <td class="text-xs-center">{{ props.item.C9_LOCAL }}</td>
                            <td class="text-xs-center">
                                <v-menu bottom left>
                                    <v-btn slot="activator" icon small>
                                        <v-icon>more_vert</v-icon>
                                    </v-btn>
                                    <v-list>
                                        <v-list-tile @click="obsShow(props.item)">
                                            <v-list-tile-avatar>
                                                <v-icon>fa-comment</v-icon>
                                            </v-list-tile-avatar>
                                            <v-list-tile-title>Mostrar observaciones</v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile @click="obsAdd(props.item)">
                                            <v-list-tile-avatar>
                                                <v-icon>add</v-icon>
                                            </v-list-tile-avatar>
                                            <v-list-tile-title>Agregar observación</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {mapActions} from 'vuex';
    import empresaSelect from '../../components/EmpresaSelect.vue';
    import filterMoneda from '../../filters/moneda';
    import filterDecimales from '../../filters/decimales';
    import filterFecha from '../../filters/fecha-micro';

    export default {
        name: "pv-vencidos",
        components: {empresaSelect},
        filters: {moneda: filterMoneda, decimales: filterDecimales, fecha: filterFecha},
        data() {
            return {
                search: '',
                loading: false,
                headers: [
                    {text: 'Fecha emis', value: 'C5_EMISSAO', align: 'center'},
                    {text: 'Fecha lib', value: 'C9_DATALIB', align: 'center'},
                    {text: 'PV', value: 'C9_PEDIDO', align: 'center'},
                    {text: 'Item', value: 'C9_ITEM', align: 'center'},
                    {text: 'Producto', value: 'C9_PRODUTO', align: 'center'},
                    {text: 'Dep', value: 'C9_LOCAL', align: 'center'},
                    {text: 'Ops', value: '', align: 'center',sortable:false},
                ],
                items: [],
                empresa_id: '',
                totalItems: 0,
                pag: {},
                rows: [10, 20, 30, {text: 'Todo', value: -1}],
            }
        },
        watch: {
            pag: {
                handler() {
                    this.datos();
                },
                deep: true
            }
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            datos() {
                if (!this.empresa_id) {
                    return false;
                }
                this.loading = true;
                this.pag.search = this.search;
                this.pag.empresa = this.empresa_id;
                this.$http.post('informes/pv-vencidos/datos?page=' + this.pag.page, this.pag)
                    .then(r => {
                        this.items = r.data.data;
                        this.totalItems = r.data.total;
                        this.loading = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading = false;
                    })
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/informes/pv-vencidos.vue